import React from 'react';

import { fieldFrame } from './fieldFrame';
import { cn } from './utils';


/**
 * Multi-line text input matching the .pen "Text input — states" (uJShi) and the
 * DESIGN.md `input` token: surface-1 bg, hairline-strong border, focus 1px
 * primary + soft glow, danger border when `invalid`. Same state language as
 * `Input`, just taller and resizable.
 */
const Textarea = React.forwardRef((props, ref) => {
  const { className, invalid = false, rows = 4, ...restProps } = props;

  return (
    <textarea
      ref={ref}
      className={cn(
        fieldFrame({ focus: 'visible', invalid }),
        'w-full px-3 py-2.5 text-table leading-normal text-ink',
        'placeholder:text-ink-subtle outline-none',
        'disabled:cursor-not-allowed disabled:opacity-45',
        'resize-y',
        className,
      )}
      rows={rows}
      {...restProps}
    />
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };
export default Textarea;
